"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchRequest = exports.valueOrArrayToArray = exports.promiseAllRateLimited = exports.limitBasedBackoff = exports.bucketedSumBy = exports.sum = exports.groupBy = void 0;
exports.assertNotNull = assertNotNull;
__exportStar(require("./asserts/assert-unreachable"), exports);
__exportStar(require("./array-sort-by"), exports);
__exportStar(require("./date-utils"), exports);
__exportStar(require("./file-extension-utils"), exports);
__exportStar(require("./executeWithExecutionTimeMeasurement"), exports);
__exportStar(require("./geo/convertArrayToLngLat"), exports);
__exportStar(require("./geo/convertLngLatToArray"), exports);
__exportStar(require("./geo/convertGeoPointToString"), exports);
__exportStar(require("./geo/isGeoPointInGeoPolygon"), exports);
__exportStar(require("./geo/isValidGeoJsonGeofenceCoordinates"), exports);
__exportStar(require("./tracing/generate-correlation-id"), exports);
__exportStar(require("./url-builders/build-trip-tracking-url"), exports);
__exportStar(require("./transformers/nullToUndefined"), exports);
__exportStar(require("./transformers/transformBookingToUTC"), exports);
__exportStar(require("./transformers/transformColorToString"), exports);
__exportStar(require("./transformers/transformDateToZonedTimeString"), exports);
__exportStar(require("./transformers/transformDateToZonedTimezone"), exports);
__exportStar(require("./transformers/transformLocalDateToBookingDate"), exports);
__exportStar(require("./transformers/transformPhoneNumberToNormalizedForm"), exports);
__exportStar(require("./transformers/transformStringToBoolean"), exports);
__exportStar(require("./transformers/transformTimeWithOffsetToUTC"), exports);
__exportStar(require("./transformers/transformTravelAgentRealizedOrdersToTier"), exports);
__exportStar(require("./transformers/transformUTCToBookingTime"), exports);
__exportStar(require("./transformers/transformUTCToTimeWithOffset"), exports);
__exportStar(require("./transformers/transformUTCtoZonedTime"), exports);
__exportStar(require("./helpers/assignationAutomation"), exports);
__exportStar(require("./helpers/assignationOffer"), exports);
__exportStar(require("./helpers/calculateUnifiedCoefficient"), exports);
__exportStar(require("./helpers/combo"), exports);
__exportStar(require("./helpers/countryNumberRounding"), exports);
__exportStar(require("./helpers/enums"), exports);
__exportStar(require("./helpers/execute-without-await"), exports);
__exportStar(require("./helpers/executeSequentially"), exports);
__exportStar(require("./helpers/feeCoefficient/getFeeCoefficientForVehicleType"), exports);
__exportStar(require("./helpers/feeCoefficient/getFeeCoefficientInPercentage"), exports);
__exportStar(require("./helpers/getAdjustedTimezone"), exports);
__exportStar(require("./helpers/getDifferenceConsideringDuplicates"), exports);
__exportStar(require("./helpers/getBasePriceFromTotalPrice"), exports);
__exportStar(require("./helpers/getFurthestDate"), exports);
__exportStar(require("./helpers/getNonEmptyStringOrUndefined"), exports);
__exportStar(require("./helpers/getStartOfCurrentDayUtc"), exports);
__exportStar(require("./helpers/getTimeDiff"), exports);
__exportStar(require("./helpers/getTimezoneOffsetOrDefault"), exports);
__exportStar(require("./helpers/is-daytrip-email"), exports);
__exportStar(require("./helpers/isLastMinuteOrder"), exports);
__exportStar(require("./helpers/isNonEmptyString"), exports);
__exportStar(require("./helpers/queryDataByDepartureAtRangeConsideringTimezone"), exports);
__exportStar(require("./helpers/padDate"), exports);
__exportStar(require("./helpers/randomization"), exports);
__exportStar(require("./helpers/removeUndefinedAndDuplicates"), exports);
__exportStar(require("./helpers/roundToDecimalPlaces"), exports);
__exportStar(require("./helpers/sleep"), exports);
__exportStar(require("./helpers/setLocalTime"), exports);
__exportStar(require("./helpers/strings/toHumanReadable"), exports);
__exportStar(require("./helpers/structuredData/generateOrderConfirmationStructuredData"), exports);
__exportStar(require("./helpers/utcToZonedTimeOrDefault"), exports);
__exportStar(require("./helpers/zonedTimeToUtcOrDefault"), exports);
__exportStar(require("./helpers/roundAndFormatDuration"), exports);
__exportStar(require("./value-checkers"), exports);
__exportStar(require("./helpers/validateEmailAddress"), exports);
__exportStar(require("./helpers/getLatestItemByDate"), exports);
__exportStar(require("./convert-price-to-currency-rounded-up"), exports);
__exportStar(require("./mongo/getStatusInQuery"), exports);
__exportStar(require("./search/searchByTerms"), exports);
__exportStar(require("./helpers/parsePhoneNumber"), exports);
__exportStar(require("./helpers/validatePhoneNumber"), exports);
__exportStar(require("./short-id"), exports);
__exportStar(require("./short-id/short-id.constants"), exports);
__exportStar(require("./is-papi-booking"), exports);
var group_by_1 = require("./group-by");
Object.defineProperty(exports, "groupBy", { enumerable: true, get: function () { return group_by_1.groupBy; } });
var sum_1 = require("./sum");
Object.defineProperty(exports, "sum", { enumerable: true, get: function () { return sum_1.sum; } });
var sum_by_1 = require("./sum-by");
Object.defineProperty(exports, "bucketedSumBy", { enumerable: true, get: function () { return sum_by_1.bucketedSumBy; } });
__exportStar(require("./withRetries"), exports);
var limit_based_backoff_1 = require("./limit-based-backoff");
Object.defineProperty(exports, "limitBasedBackoff", { enumerable: true, get: function () { return limit_based_backoff_1.limitBasedBackoff; } });
var promise_all_rate_limited_1 = require("./promise-all-rate-limited");
Object.defineProperty(exports, "promiseAllRateLimited", { enumerable: true, get: function () { return promise_all_rate_limited_1.promiseAllRateLimited; } });
__exportStar(require("./vat/getEuCountryCode"), exports);
var value_or_array_to_array_1 = require("./value-or-array-to-array");
Object.defineProperty(exports, "valueOrArrayToArray", { enumerable: true, get: function () { return value_or_array_to_array_1.valueOrArrayToArray; } });
__exportStar(require("./optional-intersection"), exports);
__exportStar(require("./are-arrays-equivalent"), exports);
__exportStar(require("./remove-from-array"), exports);
var batch_request_1 = require("./batch-request");
Object.defineProperty(exports, "batchRequest", { enumerable: true, get: function () { return batch_request_1.batchRequest; } });
__exportStar(require("./wait"), exports);
__exportStar(require("./google-maps/map-place-autocomplete-result-to-location"), exports);
__exportStar(require("./rounded-hours-formatter"), exports);
__exportStar(require("./is-booking-cache-only"), exports);
__exportStar(require("./address-types"), exports);
__exportStar(require("./isAirportAddress"), exports);
__exportStar(require("./flight-number"), exports);
__exportStar(require("./pipe"), exports);
__exportStar(require("./vehicles"), exports);
__exportStar(require("./isVehicleAllowedOldByCountry"), exports);
__exportStar(require("./vehicles/getOptimalVehiclesFromAvailable"), exports);
__exportStar(require("./convert-number-to-decimal-percentage"), exports);
__exportStar(require("./routeGeographyFlagUtils"), exports);
__exportStar(require("./closestLowerNumber"), exports);
__exportStar(require("./getPoolDepartureTimeDetails"), exports);
function assertNotNull(value, messageOrThrowable) {
    if (value === null || value === undefined) {
        if (messageOrThrowable) {
            if (typeof messageOrThrowable === "string") {
                throw new Error(messageOrThrowable);
            }
            else {
                throw messageOrThrowable;
            }
        }
        throw new Error("Value is null or undefined");
    }
}
__exportStar(require("./try-catch"), exports);
__exportStar(require("./sanitize"), exports);
__exportStar(require("./KeyGenerator"), exports);
__exportStar(require("./formatters/formatPrice"), exports);
__exportStar(require("./assert-update-successful"), exports);
//# sourceMappingURL=index.js.map